<template>
  <div class="newNavTabs">
    <div class="nav">
      <div class="navMain">
        <div class="navItem"
             v-for="item in newNavData"
             :key="item.id">
          <div class="navTop">{{item.name}}</div>
          <div class="navBottom">
            <div class="navLevel2"
                 :class="getLevel2Classes(item2)"
                 v-for="item2 in item.chd"
                 :key="item2.name"
                 @click="handleTabClick(item2)"
                 @mouseenter="navMouseEnter(item2)"
                 @mouseleave="navMouseLeave(item2)">{{item2.title}}</div>
          </div>
        </div>
      </div>
      <div class="navSecond"
           v-loading="loading"
           @mouseenter="showNavMask = false"
           @mouseleave="navSecondMouseLeave">
        <div class="navLevel3">
          <div class="title">产品维度:</div>
          <div class="tabPane"
               v-for="item,index in filterType('product')"
               :key="item.name">
            <div class="itemLabel"
                 :class="{'active':item.name == $store.state.user.ActivedTab}"
                 @mouseenter="handleMouseEnter(item,'product_'+index)"
                 @mouseleave="handleMouseLeave()">
              <div class="lb"
                   @click="handleTabClick(item)"
                   v-if="isShowEditIndex!= 'product_'+index ||tabNameValue!=item.title">{{item.title}}</div>
              <div class="lb"
                   v-if="isShowEditIndex== 'product_'+index &&tabNameValue==item.title">
                <el-input size="mini"
                          style="width:80px"
                          placeholder="请输入内容"
                          @click.stop.native=""
                          v-model="newTabNameValue">
                </el-input>
                <i class="el-icon-check"
                   @click.stop="subEditTabName(item)"></i>
                <i class="el-icon-close"
                   @click.stop="closeEditTabName()"></i>
              </div>
              <i class="el-icon-edit"
                 style="margin-left:4px;"
                 v-if="tabActiveIndex== 'product_'+index &&isShowEditIndex!='product_'+index&&item.analyse_typ!='CustomList'"
                 @click.stop="changeTabName(item,'product_'+index)"></i>
              <i class="iconfont icon-a-iconyincang2"
                 style="margin-left:4px;"
                 v-if="tabActiveIndex== 'product_'+index &&isShowEditIndex!='product_'+index&&item.analyse_typ!='CustomList'"
                 @click.stop="hideTab(item)"></i>
            </div>
          </div>
          <el-dropdown placement="bottom"
                       @command="showTab"
                       ref="dropdown">
            <div class="save"
                 style="line-height:30px;">
              更多
            </div>
            <el-dropdown-menu slot="dropdown">
              <div v-if="filterHide('product').length>0">
                <el-scrollbar style="height:100%">
                  <el-dropdown-item v-for="tag in filterHide('product')"
                                    :key="tag.name"
                                    :command="tag">{{tag.name}}</el-dropdown-item>
                </el-scrollbar>
              </div>
              <div v-if="filterHide('product').length==0">
                <el-dropdown-item disabled>暂无数据</el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="navLevel3">
          <div class="title">营销维度:</div>
          <div class="tabPane"
               v-for="item,index in filterType('market')"
               :key="item.name">
            <div class="itemLabel"
                 :class="{'active':item.name == $store.state.user.ActivedTab}"
                 @mouseenter="handleMouseEnter(item,'market_'+index)"
                 @mouseleave="handleMouseLeave()">
              <div class="lb"
                   @click="handleTabClick(item)"
                   v-if="isShowEditIndex!= 'market_'+index ||tabNameValue!=item.title">{{item.title}}</div>
              <div class="lb"
                   v-if="isShowEditIndex== 'market_'+index &&tabNameValue==item.title">
                <el-input size="mini"
                          style="width:80px"
                          placeholder="请输入内容"
                          @click.stop.native=""
                          v-model="newTabNameValue">
                </el-input>
                <i class="el-icon-check"
                   @click.stop="subEditTabName(item)"></i>
                <i class="el-icon-close"
                   @click.stop="closeEditTabName()"></i>
              </div>
              <i class="el-icon-edit"
                 style="margin-left:4px;"
                 v-if="tabActiveIndex== 'market_'+index &&isShowEditIndex!='market_'+index&&item.analyse_typ!='CustomList'"
                 @click.stop="changeTabName(item,'market_'+index)"></i>
              <i class="iconfont icon-a-iconyincang2"
                 style="margin-left:4px;"
                 v-if="tabActiveIndex== 'market_'+index &&isShowEditIndex!='market_'+index&&item.analyse_typ!='CustomList'"
                 @click.stop="hideTab(item)"></i>
            </div>
          </div>
          <el-dropdown placement="bottom"
                       @command="showTab"
                       ref="dropdown2">
            <div class="save"
                 style="line-height:30px;">
              更多
            </div>
            <el-dropdown-menu slot="dropdown">
              <div v-if="filterHide('market').length>0">
                <el-scrollbar style="height:100%">
                  <el-dropdown-item v-for="tag in filterHide('market')"
                                    :key="tag.name"
                                    :command="tag">{{tag.name}}</el-dropdown-item>
                </el-scrollbar>
              </div>
              <div v-if="filterHide('market').length==0">
                <el-dropdown-item disabled>暂无数据</el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="navLevel3">
          <div class="title">自定义标签:</div>
          <div class="tabPane"
               v-for="item,index in filterCustomTypeTab()"
               :key="item.name">
            <div class="itemLabel"
                 :class="{'active':item.name == $store.state.user.ActivedTab}"
                 @mouseenter="handleMouseEnter(item,'custom_'+index)"
                 @mouseleave="handleMouseLeave()">
              <div class="lb"
                   @click="handleTabClick(item)"
                   v-if="isShowEditIndex!= 'custom_'+index ||tabNameValue!=item.title">{{item.title}}</div>
              <div class="lb"
                   v-if="isShowEditIndex== 'custom_'+index &&tabNameValue==item.title">
                <el-input size="mini"
                          style="width:80px"
                          placeholder="请输入内容"
                          @click.stop.native=""
                          v-model="newTabNameValue">
                </el-input>
                <i class="el-icon-check"
                   @click.stop="subEditTabName(item.info)"></i>
                <i class="el-icon-close"
                   @click.stop="closeEditTabName()"></i>
              </div>
              <!-- <i class="el-icon-edit"
                 style="margin-left:4px;"
                 v-if="tabActiveIndex== 'custom_'+index &&isShowEditIndex!=index&&item.analyse_typ!='CustomList'"
                 @click.stop="changeTabName(item,index)"></i> -->
              <i class="iconfont icon-a-iconyincang2"
                 style="margin-left:4px;"
                 v-if="tabActiveIndex== 'custom_'+index &&isShowEditIndex!='custom_'+index&&item.analyse_typ!='CustomList'"
                 @click.stop="hideTab(item)"></i>
            </div>
          </div>
          <el-dropdown placement="bottom"
                       @command="showTab"
                       ref="dropdown3">
            <div class="save"
                 style="line-height:30px;">
              更多
            </div>
            <el-dropdown-menu slot="dropdown">
              <div v-if="filterHide('content').length>0">
                <el-scrollbar style="height:100%">
                  <el-dropdown-item v-for="tag in filterHide('content')"
                                    :key="tag.name"
                                    :command="tag">{{tag.name}}</el-dropdown-item>
                </el-scrollbar>
              </div>
              <div v-if="filterHide('content').length==0">
                <el-dropdown-item disabled>暂无数据</el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="navMask"
             v-if="showNavMask"></div>
      </div>
    </div>
    <!-- <div class="navCrumb"
         @mouseleave="crumbMouseLeave"
         v-show="isShowNavCrumb">
      <div class="crumbBox">
        <div class="crumb crumb1"
             ref="crumb1"
             @mouseenter="crumbMouseEnter(1)">{{navCrumbData[0]}}</div>
        <div class="crumb crumb2"
             ref="crumb2"
             @mouseenter="crumbMouseEnter(2)">> {{navCrumbData[1]}}</div>
        <div class="crumb crumb3"
             ref="crumb3"
             v-if="navCrumbData[2]"
             @mouseenter="crumbMouseEnter(3)">> {{navCrumbData[2]}}</div>
      </div>
      <div class="downMenu"
           @mouseleave="menuMouseLeave(0)">
        <div class="menu menu1"
             v-show="menu.menu1"
             ref="menu1"
             :style="{ margin: menu.menu1Margin }">
          <div v-for="item in newNavData"
               :key="item.id"
               :class="{'active':item.name == navCrumbData[0]}"
               @mouseenter="menuMouseEnter(1,item)"
               @mouseleave="menuMouseLeave(1)"
               class="menuItem">{{item.name}} <i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="menu menu2"
             v-show="menu.menu2"
             ref="menu2"
             :style="{ margin: menu.menu2Margin }">
          <div v-for="item in menu2NavData"
               :key="item.analyse_typ"
               :class="{'active':item.title == navCrumbData[1]}"
               @mouseenter="menuMouseEnter(2,item)"
               @mouseleave="menuMouseLeave(2)"
               @click="handleTabClick(item, 'crumb')"
               class="menuItem">{{item.title}} <i class="el-icon-arrow-right"
               v-if="item.analyse_typ == 'ner'"></i></div>
        </div>
        <div class="menu menu3"
             v-show="menu.menu3"
             ref="menu3"
             :style="{ margin: menu.menu3Margin }"
             @mouseleave="menuMouseLeave(3)">
          <div class="groupTitle">产品维度</div>
          <div v-for="item in filterType('product')"
               :key="item.name"
               class="menuItem"
               :class="{'active':item.title == navCrumbData[2]}"
               @click="handleTabClick(item, 'crumb')">{{item.title}}</div>
          <div class="groupTitle">营销维度</div>
          <div v-for="item in filterType('market')"
               :key="item.name"
               class="menuItem"
               :class="{'active':item.title == navCrumbData[2]}"
               @click="handleTabClick(item, 'crumb')">{{item.title}}</div>
          <div class="groupTitle">自定义分析</div>
          <div v-for="item in filterType('custom')"
               :key="item.name"
               class="menuItem"
               :class="{'active':item.title == navCrumbData[2]}"
               @click="handleTabClick(item, 'crumb')">{{item.title}}</div>
        </div>
      </div>
      <div class="pic-type-select-area">
        <el-checkbox-group v-model="picType"
                           @change="changePicType">
          <el-checkbox label="1"
                       :disabled="picType.indexOf('2') == -1">有图评论</el-checkbox>
          <el-checkbox label="2"
                       :disabled="picType.indexOf('1') == -1">无图评论</el-checkbox>
        </el-checkbox-group>
      </div>
    </div> -->
    <div class="itemSkuSelect"
         v-show="showItemRadio">
      <el-radio v-model="itemRadio"
                :label="'TopItem'">商品级</el-radio>
      <el-radio v-model="itemRadio"
                :label="'TopSku'">SKU级</el-radio>
      <el-radio v-model="itemRadio"
                :label="'title'">
        <el-select v-model="titleValue"
                   @change="titleOptionChange"
                   placeholder="自定义的商品标签"
                   size="mini">
          <el-option v-for="(item, index) in titleOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
            <div v-if="isShowTitleEditIndex != index || tabTitleNameValue != item.info.title"
                 @mouseenter="handleTitleMouseEnter(item,index)"
                 @mouseleave="handleTitleMouseLeave()"
                 style="display: flex; justify-content: space-between">
              <span style="">{{ item.label }}</span>
              <span style=" color: #8492a6; font-size: 13px">
                <i v-if="tabTitleActiveIndex == index && !item.is_hide"
                   class="el-icon-edit"
                   style="margin-left:4px;"
                   @click.stop="changeTitleTabName(item,index)"></i>
                <i v-if="tabTitleActiveIndex == index && !item.is_hide"
                   class="iconfont icon-a-iconyincang2"
                   style="margin-left:4px;"
                   @click.stop="hideTitleTab(item.info)"></i>
                <i v-if="tabTitleActiveIndex == index && item.is_hide"
                   class="iconfont icon-yanjing_xianshi_o"
                   style="margin-left:4px;"
                   title="显示"
                   @click.stop="showTitleTab(item.info)"></i>
              </span>
            </div>
            <div class="lb"
                 v-if="isShowTitleEditIndex == index && tabTitleNameValue == item.info.title">
              <el-input size="mini"
                        style="width:120px"
                        placeholder="请输入内容"
                        @click.stop.native=""
                        v-model="newTitleTabNameValue">
              </el-input>
              <i class="el-icon-check"
                 @click.stop="subEditTitleTabName(item.info)"></i>
              <i class="el-icon-close"
                 @click.stop="closeEditTitleTabName()"></i>
            </div>
          </el-option>
          <template slot="empty">
            <div class="expandHide"
                 @click="showTitleHide">
              显示全部
            </div>
          </template>
          <div class="expandHide"
               @click="showTitleHide">
            显示全部
          </div>
        </el-select>
      </el-radio>
    </div>
  </div>

</template>


<script>
export default {
  name: 'NavTabs',
  props: {
    navData: {
      type: Array,
      default: () => [],
    },
    hideTabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showNavMask: true,
      newNavData: [
        {
          name: '核心指标',
          id: 1,
          chd: [
            {
              analyse_typ: 'Summary',
              custom_typ: '',
              name: 'Summary',
              rule_id: '',
              title: '基本信息',
            },
            {
              analyse_typ: 'EachSound',
              custom_typ: 'content',
              name: 'EachSound',
              rule_id: '',
              title: '方面/观点',
            },
          ],
        },
        {
          name: '产品指标',
          id: 2,
          chd: [
            {
              analyse_typ: 'a390cc28-1ea9-4050-8120-cfd72dc4adf8',
              anta_target: '',
              custom_typ: 'content',
              name: 'a390cc28-1ea9-4050-8120-cfd72dc4adf8',
              ner_type: 'DrivingFactors',
              rule_id: 'a390cc28-1ea9-4050-8120-cfd72dc4adf8',
              title: '驱动因素',
            },
            {
              analyse_typ: 'ner',
              name: 'ner',
              origin_user: '',
              rule_id: 'f5debfca-5585-473a-ab31-920fe54dd28e',
              title: '标签分析',
            },
            {
              analyse_typ: 'custom_content',
              name: 'Customaspect',
              origin_user: '',
              rule_id: '',
              title: '定制评论标签',
            },
          ],
        },
        {
          name: '运营指标',
          id: 3,
          chd: [
            {
              analyse_typ: 'CatList',
              custom_typ: '',
              name: 'CatList',
              rule_id: '',
              title: '类目分析',
            },
            {
              analyse_typ: 'TopBrand',
              custom_typ: '',
              name: 'TopBrand',
              rule_id: '',
              title: '品牌分析',
            },

            {
              analyse_typ: 'TopShop',
              custom_typ: '',
              name: 'TopShop',
              rule_id: '',
              title: '店铺分析',
            },
            {
              analyse_typ: 'TopItem',
              analyse_typ_2: 'TopSku',
              custom_typ: '',
              name: 'TopItem',
              rule_id: '',
              title: '商品/SKU分析',
            },
            // {
            //   analyse_typ: 'TopAttr',
            //   custom_typ: '',
            //   name: 'TopAttr',
            //   rule_id: '',
            //   title: '属性分析',
            // },
            {
              analyse_typ: 'custom_title',
              name: 'custom_title',
              origin_user: '',
              rule_id: '',
              title: '定制商品标签',
            },
          ],
        },
        {
          name: 'AI+',
          id: 4,
          chd: [
            {
              analyse_typ: 'AiInterpret',
              name: 'AiInterpret',
              origin_user: '',
              rule_id: '',
              title: 'DeepSeek解读',
            },
          ],
        },
      ],
      level2Data: [
        'Summary',
        'EachSound',
        'BaseInfo',
        'CatList',
        'TopBrand',
        'TopShop',
        'TopItem',
        'Customaspect',
        'a390cc28-1ea9-4050-8120-cfd72dc4adf8',
      ],
      level3Data: [],
      tabActiveIndex: -1,
      isShowEditIndex: -1,
      isShowTitleEditIndex: -1,
      tabTitleActiveIndex: -1,
      tabNameValue: '',
      tabTitleNameValue: '',
      newTabNameValue: '',
      newTitleTabNameValue: '',
      showThird: 'ner',
      itemRadio: 'TopItem',
      showItemRadio: false,
      isShowNavCrumb: false,
      menu: {
        menu1: false,
        menu1Margin: '0px',
        menu2: false,
        menu2Margin: '0px',
        menu3: false,
        menu3Margin: '0px',
      },
      menu2NavData: [],
      menu3NavData: [],
      picType: this.$store.state.user.picType.split(','),
      titleOptions: [],
      titleValue: '',
      crumbType: false,
      loading: false,
    }
  },
  methods: {
    navSecondMouseLeave(e) {
      if (!e.relatedTarget || this.isLabelAnalysis) {
        return
      }
      this.showNavMask = true
    },
    getLevel2Classes(item) {
      const ActivedTab = this.$store.state.user.ActivedTab
      const temp = {
        active: item.analyse_typ == this.$store.state.user.ActivedTab,
        ner_arrow: item.analyse_typ == 'ner',
        navLevelActive: item.analyse_typ == 'ner' && !this.showNavMask,
      }

      if (this.$store.state.user.ActivedTab == 'Customaspect') {
        const customEditTyp = this.$store.state.user.customEditTyp
        if (customEditTyp == 'title') {
          temp.active = item.title == '定制商品标签'
        } else {
          temp.active = item.title == '定制评论标签'
        }
      }
      if (
        this.navData.findIndex((item) => {
          return item.rule_id == ActivedTab && item.custom_typ == 'title'
        }) > -1
      ) {
        temp.active = item.title == '商品/SKU分析'
        temp.navLevelActive = item.title == '商品/SKU分析'
      }
      if (this.$store.state.user.ActivedTab == 'TopSku') {
        temp.active = item.title == '商品/SKU分析'
        temp.navLevelActive = item.title == '商品/SKU分析'
      }
      return temp
    },
    showTitleHide() {
      const titleHideArr = this.filterHide('title')
      const options_1 = this.filterCustomType('title').map((item) => {
        return {
          value: item.rule_id,
          label: item.title,
          info: item,
        }
      })
      const options_2 = titleHideArr.map((item) => {
        return {
          value: item.rule_id,
          label: item.name,
          info: item,
          is_hide: true,
        }
      })
      this.titleOptions = [...options_1, ...options_2]
    },
    filterType(typ) {
      let arr = _.filter(this.level3Data, function (o) {
        return (
          o.tab_typ == typ && o.name != 'a390cc28-1ea9-4050-8120-cfd72dc4adf8'
        )
      })
      return arr
    },
    filterCustomType(typ) {
      let arr = _.filter(this.level3Data, function (o) {
        return (
          o.custom_typ == typ &&
          o.tab_typ == 'custom' &&
          o.rule_id !== 'a390cc28-1ea9-4050-8120-cfd72dc4adf8'
        )
      })
      return arr
    },
    filterCustomTypeTab() {
      let arr = _.filter(this.level3Data, function (o) {
        return (
          (o.custom_typ == 'content' || o.custom_typ == 'by_gpt') &&
          o.tab_typ == 'custom' &&
          o.rule_id !== 'a390cc28-1ea9-4050-8120-cfd72dc4adf8'
        )
      })
      return arr
    },
    filterHide(typ) {
      const self = this
      let arr = _.filter(this.hideTabs, function (o) {
        if (typ == 'market' || typ == 'product') {
          return o.tab_typ == typ
        } else if (typ == 'content' || typ == 'title') {
          return o.tab_typ == 'custom' && o.custom_typ == typ
        }
      })
      return arr
    },
    handleTabClick(item, from) {
      if (from == 'crumb') {
        this.crumbType = true
      } else {
        this.crumbType = false
      }
      if (item.analyse_typ == 'ner') {
        this.showThird = item.analyse_typ
        this.showItemRadio = false
        this.itemRadio = 'TopItem'
        return
      }
      if (item.analyse_typ == 'custom_content') {
        this.showItemRadio = false
        this.itemRadio = 'TopItem'
        const customItem = {
          analyse_typ: 'custom_content',
          name: 'Customaspect',
          origin_user: '',
          rule_id: '',
          title: '定制评论标签',
        }

        this.$parent.editableTabsValue = customItem.name
        this.$parent.handleTabClick(customItem)
        this.$store.dispatch('user/changeCustomEditTyp', 'content')
        return
      }
      if (item.analyse_typ == 'custom_title') {
        this.showItemRadio = false
        this.itemRadio = 'TopItem'
        const customItem = {
          analyse_typ: 'custom_title',
          name: 'Customaspect',
          origin_user: '',
          rule_id: '',
          title: '定制商品标签',
        }

        this.$parent.editableTabsValue = customItem.name
        this.$parent.handleTabClick(customItem)
        this.$store.dispatch('user/changeCustomEditTyp', 'title')
        return
      }
      if (
        item.analyse_typ == 'TopItem' ||
        item.analyse_typ == 'TopSku' ||
        item.custom_typ == 'title'
      ) {
        this.showItemRadio = true
        this.$parent.editableTabsValue = item.name
        this.$parent.handleTabClick(item)
        return
      } else {
        this.showItemRadio = false
        this.itemRadio = 'TopItem'
      }
      if (item.name == 'AiInterpret') {
        this.$parent.editableTabsValue = item.name
        this.$parent.aiInterpretFuc()
        return
      }

      this.$parent.editableTabsValue = item.name
      this.$parent.handleTabClick(item)
    },
    handleMouseEnter(item, index) {
      this.tabActiveIndex = index
    },
    handleMouseLeave() {
      this.tabActiveIndex = -1
    },
    handleTitleMouseEnter(item, index) {
      this.tabTitleActiveIndex = index
    },
    handleTitleMouseLeave() {
      this.tabTitleActiveIndex = -1
    },
    subEditTabName(item) {
      this.loading = true
      let obj = {
        title: {
          from: item.title,
          to: this.newTabNameValue,
          name: item.name,
        },
      }
      this.$parent.modifyTabName(obj, this.newTabNameValue)
    },
    subEditTitleTabName(item) {
      let obj = {
        title: {
          from: item.title,
          to: this.newTitleTabNameValue,
          name: item.name,
        },
      }
      this.$parent.modifyTabName(obj, this.newTitleTabNameValue)
    },
    closeEditTabName() {
      this.tabNameValue = ''
      this.newTabNameValue = ''
      this.isShowEditIndex = -1
    },
    closeEditTitleTabName() {
      this.tabTitleNameValue = ''
      this.newTitleTabNameValue = ''
      this.isShowTitleEditIndex = -1
    },
    changeTabName(item, index) {
      this.newTabNameValue = item.title
      this.tabNameValue = item.title
      this.isShowEditIndex = index
    },
    changeTitleTabName(item, index) {
      this.newTitleTabNameValue = item.info.title
      this.tabTitleNameValue = item.info.title
      this.isShowTitleEditIndex = index
    },
    hideTab(item) {
      this.loading = true
      let obj = {
        hide: {
          from: '',
          to: true,
          name: item.name,
        },
      }
      this.$parent.hideTab(obj)
    },
    hideTitleTab(item) {
      this.$confirm('此操作将隐藏该标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let obj = {
            hide: {
              from: '',
              to: true,
              name: item.name,
            },
          }
          this.$parent.hideTab(obj)
          this.itemRadio = 'TopItem'
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消隐藏操作',
          })
        })
    },
    showTitleTab(item) {
      this.$parent.deleteHideTabs(item)
      this.itemRadio = 'TopItem'
    },
    showTab(item) {
      this.loading = true
      // let obj = {
      //   hide: {
      //     from: '',
      //     to: false,
      //     name: item.analyse_typ ? item.analyse_typ : item.rule_id,
      //     analyse_typ: item.analyse_typ,
      //   },
      // }
      this.$parent.deleteHideTabs(item)
    },
    crumbMouseLeave(event) {
      const childEl = this.$el.querySelector('.downMenu')
      const enteredChild = childEl.contains(event.relatedTarget)
      // 如果没有进入子元素，或 relatedTarget 为 null（完全离开）
      if (!enteredChild || !event.relatedTarget) {
        this.menu.menu1 = false
        this.menu.menu2 = false
        this.menu.menu3 = false
      }
    },
    crumbMouseEnter(val) {
      const width1 = this.$refs.crumb1.offsetWidth
      const width2 = this.$refs.crumb2.offsetWidth
      if (val == 1) {
        this.menu.menu1 = true
        this.menu.menu2 = false
        this.menu.menu3 = false
      } else if (val == 2) {
        this.menu.menu1 = false
        this.menu.menu2 = true
        this.menu.menu2Margin = `0 0 0 ${width1 + 20}px`
        this.menu.menu3 = false
        if (this.navCrumbData[2]) {
          this.menu.menu3 = true
          this.menu.menu3Margin = `0`
          this.menu2NavData = this.newNavData[2].chd
        } else {
          let obj = _.find(this.newNavData, (o) => {
            return o.name == this.navCrumbData[0]
          })
          this.menu2NavData = obj.chd
        }
      } else if (val == 3) {
        this.menu.menu1 = false
        this.menu.menu2 = false
        this.menu.menu3 = true
        this.menu.menu3Margin = `0 0 0 ${width1 + width2 + 20}px`
      }
    },
    menuMouseLeave(val) {
      if (val == 0) {
        this.menu.menu1 = false
        this.menu.menu2 = false
        this.menu.menu3 = false
      } else if (val == 3 && !this.menu.menu2) {
        this.menu.menu1 = false
        this.menu.menu2 = false
        this.menu.menu3 = false
      }
    },
    menuMouseEnter(val, data) {
      if (val == 1) {
        this.menu.menu2 = true
        // this.menu.menu2Margin = `${data.id * 28 - 28}px 1px 0`
        this.menu.menu2Margin = `0`
        if (data && data.chd) {
          this.menu2NavData = data.chd
        }
        this.menu.menu3 = false
        this.menu3NavData = []
      } else if (val == 2) {
        this.menu.menu3Margin = `0`
        if (data && data.analyse_typ == 'ner') {
          this.menu.menu3 = true
          this.menu3NavData = this.level3Data
        } else {
          this.menu.menu3 = false
          this.menu3NavData = []
        }
      }
    },
    findParentByAnalyseTyp(data, targetAnalyseTyp) {
      return _.find(data, (item) => {
        return _.some(item.chd, { analyse_typ: targetAnalyseTyp })
      })
    },
    changePicType(val) {
      this.$store.dispatch('user/changePicType', val.join(','))
    },
    navMouseEnter(item) {
      if (item.analyse_typ != 'ner') {
        this.showNavMask = true
      } else {
        this.showNavMask = false
      }
    },
    navMouseLeave(item) {
      if (item.analyse_typ != 'ner') {
        this.showNavMask = true
      } else {
        this.showNavMask = false
      }
    },
    titleOptionChange(value) {
      this.itemRadio = 'title'
      let item = this.titleOptions.find((item) => item.value == value)
      if (item) {
        if (item.is_hide) {
          item.info.title = item.info.name
        }
        this.handleTabClick(item.info)
      }
    },
  },
  computed: {
    navCrumbData() {
      let arr = ['', '', '']
      const result = this.findParentByAnalyseTyp(
        this.newNavData,
        this.$store.state.user.ActivedTab
      )
      if (result) {
        arr[0] = result.name
        arr[1] = _.find(result.chd, (item) => {
          return item.analyse_typ == this.$store.state.user.ActivedTab
        }).title
        this.menu2NavData = result.chd
      } else {
        //未找到匹配项表示为产品/营销/自定义的nav
        this.menu2NavData = this.newNavData[2].chd
        let titleItem = _.find(this.level3Data, (o) => {
          return (
            o.analyse_typ == this.$store.state.user.ActivedTab ||
            o.name == this.$store.state.user.ActivedTab
          )
        })
        let title = ''
        if (titleItem) {
          title = titleItem.title
        }
        arr = ['产品指标', '标签分析', title]
      }
      return arr
    },
    isLabelAnalysis() {
      let data = this.level3Data.concat(this.hideTabs)
      let obj = _.find(data, (o) => {
        return (
          o.analyse_typ == this.$store.state.user.ActivedTab ||
          o.name == this.$store.state.user.ActivedTab ||
          o.rule_id == this.$store.state.user.ActivedTab
        )
      })
      if (obj) {
        return true
      } else {
        return false
      }
    },
  },
  created() {
    this.$eventBus.$on('showNavCrumb', (val) => {
      if (this.crumbType) {
        this.crumbType = false
        return
      }
      this.isShowNavCrumb = val
      if (this.$refs.dropdown) {
        this.$refs.dropdown.hide()
      }
      if (this.$refs.dropdown2) {
        this.$refs.dropdown2.hide()
      }
      if (this.$refs.dropdown3) {
        this.$refs.dropdown3.hide()
      }
    })
    const _this = this
    if (this.$store.state.user.loginInfo.is_partner) {
      this.newNavData = _.filter(this.newNavData, function (o) {
        return o.id != 4
      })
    }
    this.level3Data = _.filter(this.navData, function (o) {
      return !_this.level2Data.includes(o.analyse_typ)
    })
  },
  watch: {
    navData: {
      handler(newVal, oldVal) {
        const _this = this
        if (this.$store.state.user.loginInfo.is_partner) {
          this.newNavData = _.filter(this.newNavData, function (o) {
            return o.id != 4
          })
        }
        if (newVal.findIndex((item) => item.analyse_typ == 'TopAttr') > -1) {
          this.newNavData[2].chd.splice(4, 0, {
            analyse_typ: 'TopAttr',
            custom_typ: '',
            name: 'TopAttr',
            rule_id: '',
            title: '属性分析',
          })
        } else {
          const index = this.newNavData[2].chd.findIndex(
            (item) => item.analyse_typ == 'TopAttr'
          )
          if (index > -1) {
            this.newNavData[2].chd.splice(index, 1)
          }
        }
        this.level3Data = _.filter(newVal, function (o) {
          return !_this.level2Data.includes(o.analyse_typ)
        })
        this.titleOptions = this.filterCustomType('title').map((item) => {
          return {
            value: item.rule_id,
            label: item.title,
            info: item,
          }
        })
        this.loading = false
      },
    },
    '$store.state.user.loginInfo': {
      handler(newVal, oldVal) {
        if (newVal.is_partner) {
          this.newNavData = _.filter(this.newNavData, function (o) {
            return o.id != 4
          })
        }
      },
    },
    itemRadio: {
      handler(newVal, oldVal) {
        if (newVal == oldVal) {
          return
        }
        if (newVal == 'TopItem' && this.showItemRadio) {
          const item = {
            analyse_typ: 'TopItem',
            custom_typ: '',
            name: 'TopItem',
            rule_id: '',
            title: '商品分析',
          }
          this.handleTabClick(item)
        } else if (newVal == 'TopSku') {
          const item = {
            analyse_typ: 'TopSku',
            custom_typ: '',
            name: 'TopSku',
            rule_id: '',
            title: 'SKU分析',
          }
          this.handleTabClick(item)
        } else if (newVal == 'title') {
          if (!this.titleOptions[0]) {
            return
          }
          if (!this.titleValue) {
            this.titleValue = this.titleOptions[0].value
            this.titleOptionChange(this.titleValue)
          } else {
            this.titleOptionChange(this.titleValue)
          }
        }
      },
    },
    '$store.state.user.picType': {
      handler(newVal) {
        this.picType = newVal.split(',')
      },
    },
    '$store.state.user.ActivedTab': {
      handler(newVal, oldVal) {
        if (!this.level2Data.includes(newVal) && !this.showItemRadio) {
          this.showNavMask = false
        } else {
          this.showNavMask = true
        }
      },
    },
  },
}
</script>

<style lang="less" scoped>
.newNavTabs {
  padding-top: 8px;
  border-top: 1px solid #e6e6e6;
  .iconfont {
    font-size: 12px;
  }
  .nav {
    margin-bottom: 20px;
    .navMain {
      display: flex;
      .navItem {
        margin-right: 30px;
        .navTop {
          padding: 6px 20px;
          border-top-right-radius: 14px;
          background: #fe7d00;
          color: #fff;
          font-size: 14px;
          text-align: center;
          display: inline-block;
          white-space: nowrap;
        }
        .navBottom {
          background: #fff;
          color: #000;
          font-size: 14px;
          display: flex;
          padding: 0 10px;
          .navLevel2 {
            padding: 10px 10px;
            cursor: pointer;
          }
          .ner_arrow {
            position: relative;
          }
          .ner_arrow::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translateX(-10px);
            width: 0;
            height: 0;
            border-left: 14px solid transparent;
            border-right: 14px solid transparent;
            border-bottom: 14px solid #fff;
          }
          .navLevel2:hover {
            color: #fe7d00;
          }
          .navLevel2.active {
            color: #fe7d00;
            font-weight: 600;
          }
          .navLevel2.navLevelActive {
            color: #fe7d00;
          }
        }
      }
    }
    .navSecond {
      width: 100%;
      padding: 20px 30px;
      margin-top: 20px;
      box-sizing: border-box;
      background: #fff;
      position: relative;
      .navMask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        opacity: 0.6;
      }
      .navLevel3 {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .title {
          margin-right: 20px;
          line-height: 30px;
          font-size: 14px;
        }
        .tabPane {
          flex-wrap: nowrap;
          margin-bottom: 4px;
          .itemLabel {
            padding: 4px 12px;
            border: 1px solid #e9e9eb;
            color: #303133;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            font-size: 12px;
            .lb {
              display: inline-block;
            }
          }
          .itemLabel.active {
            color: #fe7d00;
            border-color: #fe7d00;
          }
        }
      }
      .navLevel3:nth-of-type(3) {
        margin-bottom: 0;
      }
    }
  }
  .itemSkuSelect {
    background-color: #fff;
    padding-top: 10px;
    padding-left: 25px;
  }
  .navCrumb {
    position: relative;
    padding: 0 0 10px 10px;
    .crumbBox {
      display: flex;
      .crumb {
        margin-right: 6px;
        cursor: pointer;
        font-weight: 600;
      }
      .crumb:hover {
        color: #3a63f3;
      }
    }
    .downMenu {
      position: absolute;
      left: 0;
      top: 24px;
      display: flex;
      //   align-items: flex-start;
      z-index: 99;
      .menu {
        text-align: left;
        min-width: 120px;
        width: auto;
        border: 1px solid #e4e7ed;
        background: #fff;
        box-shadow: 4px 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        .menuItem {
          padding: 0 24px 0 15px;
          height: 34px;
          line-height: 34px;
          box-sizing: border-box;
          cursor: pointer;
          font-size: 14px;
          position: relative;
          color: #4a4a4a;
          font-size: 14px;
          i {
            position: absolute;
            right: 6px;
            top: 0;
            line-height: 34px;
          }
        }
        .menuItem:hover {
          color: #3a63f3;
          background: #f5f7fa;
        }
      }
      .menu2 {
        margin-left: 1px;
        margin-right: 1px;
        margin-top: 20px;
      }
      .menu3 {
        min-width: 140px;
        margin-top: 40px;
        max-height: 224px;
        overflow-y: auto;
        .groupTitle {
          padding: 4px 6px;
          user-select: none;
          color: #333333;
          font-size: 12px;
        }
      }
    }
    .active {
      color: #3a63f3;
    }
    .pic-type-select-area {
      position: absolute;
      top: 0;
      right: 10px;
    }
  }
}
</style>
<style lang="less">
.expandHide {
  padding: 8px 20px;
  font-size: 12px;
  cursor: pointer;
  color: #fe7d00;
}
</style>
